import { Inlines } from '../Inlines';

export default function QuoteBlock({ block }) {
  return (
    <blockquote className="content-quote">
      <p>
        <Inlines nodes={block.children} />
      </p>
    </blockquote>
  );
}
